import { Injectable, NgZone } from '@angular/core';
import { AppConfig } from '../config';

@Injectable()
export class ScannerServiceProvider {
  public Scandit: any;
  public contentHeight;
  public delegate: ScannerDelegate;

  private picker;
  private _contentTop: number = 0;

  private portraitConstraints: Constraints;
  private landscapeConstraints: Constraints;

  constructor(
    private zone: NgZone,
  ) {
    if(Scandit.License)  {
    Scandit.License.setAppKey(AppConfig.constants.SCANDIT_KEY);
    var settings = new Scandit.ScanSettings();
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.PDF417, true);
    settings.highDensityModeEnabled = true;
    settings.torchEnabled = true;
    this.picker = new Scandit.BarcodePicker(settings);
    // this.picker.getOverlayView().setGuiStyle(Scandit.ScanOverlay.GuiStyle.LASER);
    this.picker.getOverlayView().setViewfinderColor("F59953");
    this.picker.getOverlayView().setViewfinderDecodedColor("a3e7be");
    this.picker.getOverlayView().setTorchEnabled(true);
    }
    else {
      console.log("Running ont the web")
    }
  }

  public get contentTop(): number {
    return this._contentTop;
  }

  public set contentTop(newValue: number) {
    this._contentTop = newValue;
    this.setScannerConstraints();
  }

  public start(): void {
    // We only want to pause the scanner if not in continuous mode, not stop it, so we're setting it to true here
    this.picker.continuousMode = true;

    this.picker.show({
      didScan: session => {
        if (this.delegate) {
          this.zone.run(() => {
            this.delegate.didScan(session);
          })
        }
      },
    });
    this.picker.startScanning();
  }

  public resume(): void {
    this.picker.resumeScanning();
  }

  public cancel(): void {
    this.picker.cancel();
  }

  // ================================================ //
  // ===== Constraint setting & related helpers ===== //
  // ================================================ //

  private setScannerConstraints(): void {
    const top = this.contentTop;
    if (top === undefined) {
      setTimeout(this.setScannerConstraints.bind(this), 500);
    }

    const topConstraint = top || 0;
    const rightConstraint = 0;
    const bottomConstraint = screen.height / 4;
    const leftConstraint = 0;

    this.contentHeight = screen.height - bottomConstraint - topConstraint;

    console.log(this.contentHeight, topConstraint, rightConstraint, bottomConstraint, leftConstraint);
    this.setConstraints(topConstraint, rightConstraint, bottomConstraint, leftConstraint);
  }

  private setConstraints(top: Constraint, right: Constraint, bottom: Constraint, left: Constraint, animationDuration: number = 0): void {
    const newConstraints = this.getConstraintsWith(top, right, bottom, left);
    this.setPortraitConstraints(newConstraints, animationDuration);
    this.setLandscapeConstraints(newConstraints, animationDuration);
  }

  private setPortraitConstraints(newConstraints: Constraints, animationDuration: number = 0): void {
    if (this.needsConstraintUpdates(this.portraitConstraints, newConstraints)) {
      this.portraitConstraints = newConstraints;
      this.applyConstraints(animationDuration);
    }
  }

  private setLandscapeConstraints(newConstraints: Constraints, animationDuration: number = 0): void {
    if (this.needsConstraintUpdates(this.landscapeConstraints, newConstraints)) {
      this.landscapeConstraints = newConstraints;
      this.applyConstraints(animationDuration);
    }
  }

  private getConstraintsWith(top: Constraint, right: Constraint, bottom: Constraint, left: Constraint, animationDuration: number = 0): Constraints {
    const newConstraints = new Scandit.Constraints();
    newConstraints.topMargin = top;
    newConstraints.rightMargin = right;
    newConstraints.bottomMargin = bottom;
    newConstraints.leftMargin = left;
    return newConstraints;
  }

  private needsConstraintUpdates(constraint: Constraints, newConstraints: Constraints): boolean {
    return !constraint ||
    newConstraints.topMargin !== constraint.topMargin ||
    newConstraints.rightMargin !== constraint.rightMargin ||
    newConstraints.bottomMargin !== constraint.bottomMargin ||
    newConstraints.leftMargin !== constraint.leftMargin
  }

  private applyConstraints(animationDuration: number = 0): void {
    this.picker.setConstraints(this.portraitConstraints, this.landscapeConstraints, animationDuration);
  }

}



// WEBPACK FOOTER //
// ./src/providers/scanner-service/scanner-service.ts